import * as Yup from "yup";

const nfseEditarValidator = Yup.object().shape({
  clienteId: Yup.number("Cliente").required("Cliente"),
  clienteNome: Yup.string().required("Cliente"),
  clienteCnpjCpf: Yup.string().required("Cliente"),
  clienteEnderecoRua: Yup.string().nullable(),
  clienteEnderecoNumero: Yup.string().nullable(),
  clienteEnderecoBairro: Yup.string().nullable(),
  clienteEnderecoComplemento: Yup.string().nullable(),
  clienteEnderecoCidade: Yup.string().nullable(),
  clienteEnderecoUf: Yup.string().nullable(),
  clienteEnderecoCep: Yup.string().nullable(),
  descricaoServico: Yup.string().required("Descrição do serviço"),
  dataPrestacao: Yup.date().nullable(),
});

export default nfseEditarValidator;
